import { Controller } from "@hotwired/stimulus"

// Switches which role panel is visible inside the membre "Performance par rôle"
// module. Active state is mirrored on both tabs and panels via the
// `mbm_role-tab--active` / `mbm_role-panel--active` modifier classes. The
// selected role is also reflected in the URL hash (e.g. `#role=charge_rh`)
// so the choice survives reloads and back-navigation.
export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    const fromHash = this._readHash()
    if (fromHash && this._roleExists(fromHash)) {
      this._activate(fromHash, { updateHash: false })
    }
  }

  select(event) {
    const role = event.currentTarget.dataset.role
    if (!role) return
    if (event.currentTarget.disabled) return
    this._activate(role)
  }

  // ------------------------------------------------------------------

  _activate(role, { updateHash = true } = {}) {
    this.tabTargets.forEach(t => {
      const match = t.dataset.role === role
      t.classList.toggle("mbm_role-tab--active", match)
      t.setAttribute("aria-selected", match ? "true" : "false")
    })
    this.panelTargets.forEach(p => {
      p.classList.toggle("mbm_role-panel--active", p.dataset.role === role)
    })
    if (updateHash) {
      const hash = `#role=${encodeURIComponent(role)}`
      history.replaceState(null, "", hash)
    }
  }

  _roleExists(role) {
    return this.tabTargets.some(t => t.dataset.role === role && !t.disabled)
  }

  _readHash() {
    const m = window.location.hash.match(/role=([^&]+)/)
    return m ? decodeURIComponent(m[1]) : null
  }
}
